<template>
  <DatePicker
    :capture="dateOptions.capture"
    :clearable="dateOptions.clearable"
    :confirm="dateOptions.confirm"
    :disabled="dateOptions.disabled"
    :editable="dateOptions.editable"
    :element-id="dateOptions.elementId"
    :format="dateOptions.format"
    :multiple="dateOptions.multiple"
    :open="dateOptions.open"
    :options="dateOptions.options"
    :placeholder="dateOptions.placeholder"
    :placement="dateOptions.placement"
    :readonly="dateOptions.readonly"
    :separator="dateOptions.separator"
    :show-week-numbers="dateOptions.showWeekNumbers"
    :size="dateOptions.size"
    :split-panels="dateOptions.splitPanels"
    :start-date="dateOptions.startDate"
    :time-picker-options="dateOptions.timePickerOptions"
    :transfer="dateOptions.transfer"
    :type="dateOptions.type"
    @on-change="_onChange"
    @on-clear="_onClear"
    @on-clickoutside="_onClickoutside"
    @on-ok="_onOk"
    @on-open-change="_onOpen"
    style="width: 100%"
    v-model="desDate"
  >
    <slot></slot>
  </DatePicker>
</template>

<script>
import { deepCopy, isDate, isString } from '@Utils/index'
const COMPONENT_NAME = 'DatePickers'
export default {
  emits: ['input', 'on-change', 'on-clear', 'on-open-change', 'on-ok', 'on-clickoutside'],
  name: COMPONENT_NAME,
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    value: {
      type: [String, Number, Date],
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    accept: {
      type: String,
      default: 'number'
    }
  },
  watch: {
    value: {
      handler(nv, ov) {
        if (nv !== ov) {
          this.$data.desDate = this._getDate()
        }
      }
    }
  },
  data() {
    const oterOpts = {}
    if (this.placeholder) {
      oterOpts.placeholder = this.placeholder
    }
    return {
      desDate: this._getDate(),
      dateOptions: {
        type: 'date',
        format: 'yyyy-MM-dd',
        placement: 'bottom-start',
        placeholder: '选择日期',
        options: {},
        splitPanels: false,
        multiple: false,
        showWeekNumbers: false,
        startDate: new Date(),
        confirm: false,
        open: null,
        size: 'default',
        disabled: false,
        clearable: false,
        readonly: false,
        editable: false,
        transfer: false,
        elementId: '',
        timePickerOptions: {},
        separator: ' - ',
        capture: true,
        fixTimestamp: true,
        ...oterOpts
      }
    }
  },
  created() {
    this.dateOptions = {
      ...this.dateOptions,
      ...this.options
    }
  },
  methods: {
    _getDate() {
      const val = deepCopy(this.value)
      if (val && !isDate(val)) {
        return new Date(val)
      }
      return val
    },
    _emitVal(ts) {
      this.$emit('input', ts)
    },
    _onOpen() {},
    _onChange(date, type) {
      const dateReg = /^((\d{4}-)?\d{2}-\d{2})((\s)*\d\d(:\d\d)+)?$/
      if (isString(this.value)) {
        if (this.dateOptions.fixTimestamp && this.dateOptions.type === 'date') {
          date = date.replace(dateReg, '$1 23:59:59')
        }
        // val = date
      }
      date = date.replace(/-/g, '/')
      if (isDate(this.value)) {
        date = new Date(date)
      }
      this._emitVal(date)
      this.$emit('on-change', new Date(date).getTime())
    },
    _onClear() {
      this._emitVal('')
      this.$emit('on-clear', '')
    },
    _onOpenChange(data) {
      this.$emit('on-open-change', data)
    },
    _onOk(data) {
      this.$emit('on-ok', data)
    },
    _onClickoutside(event) {
      this.$emit('on-clickoutside', event)
    }
  }
}
</script>
